module.exports = __webpack_public_path__ + "img/limit-his-land-2.7271d834.jpg";